import { webhooksApi } from '~/apis/webhooksApi'
import { useUserState } from '~/atoms/UserState'

import { AuthorizationKeysSection } from '@mangovoice/webhooks-ui'

export const ApiAccessPage = () => {
  const { pbxId } = useUserState()

  if (!pbxId) return null

  return <AuthorizationKeysSection api={webhooksApi} pbxId={pbxId} />
}
